"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ApiService_1 = require("../services/ApiService");
var Card = /** @class */ (function () {
    function Card(character, name, level, inPlayerDeck, inScenarioDeck) {
        this.name = name;
        this.level = level;
        this.imgUrl = ApiService_1.ApiService.cardImageUrl(character, this.name);
        this.inPlayerDeck = Card.alwaysInPlayerDeck(this) || inPlayerDeck;
        this.inScenarioDeck = inScenarioDeck;
    }
    Card.alwaysInPlayerDeck = function (card) {
        return card.level === "X" || card.level === "1" || card.level === "M";
    };
    __decorate([
        mobx_1.observable
    ], Card.prototype, "inPlayerDeck", void 0);
    __decorate([
        mobx_1.observable
    ], Card.prototype, "inScenarioDeck", void 0);
    __decorate([
        mobx_1.observable
    ], Card.prototype, "imgUrl", void 0);
    return Card;
}());
exports.Card = Card;



//////////////////
// WEBPACK FOOTER
// ./src/models/Card.ts
// module id = 244
// module chunks = 0